import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FiDataFieldViewBase } from '../data-field-view-base';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'data-field-view-cluster',
    templateUrl: './cluster.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FiDataFieldViewClusterComponent extends FiDataFieldViewBase {
    FiStateNames = FiStateNames;

    get isNotEmpty() {
        return !!this.dataFieldObject.ClusterId;
    }
}
